// api.js
import axios from 'axios'

// DRN
// export const baseURL = 'http://192.168.0.105:1538/'
export const baseURL = 'https://melon.invtechnologies.in/'

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json', },
})

// DNR Billing
// login API
export const loginDNR = (data) =>
  api.post('bill/user/login-user', data);

// /bill/dashboard-stats/:user_id
export const dnrDashboardStatsbyId = (id) =>
  api.get(`bill/dashboard-stats/${id}`);

export const getAllDNROrders = (params, body) =>
  api.post(`bill/fetch-orders?page=${params.page}&limit=${params.limit}`, body);

export default api;